import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { createTnC } from '../../redux/actions/tnc';

import TncCreate from './TncCreate.page';

const mapStateToProps = state => ({
  detail: state.allbiller.tncDetail,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = { createTnC };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TncCreate));
